import http from '../request/index'

//分销佣金排行榜
export const GetUserCommissionRankList = (params) => {
  return http.post('/api/UserCommisson/GetUserCommissionRankList', params)
}